<template>
  <div ref="cell" class="grid-view__cell">
    <div class="grid-field-text">
      <SearchHighlightedText :text="value" :search-term="searchTerm" />
    </div>
  </div>
</template>

<script>
/**
 * The unselected phone number cell.
 *
 * This component already existed but nothing referenced it: `PhoneNumberFieldType`
 * pointed its functional slot at `FunctionalGridViewFieldURL` instead. That was
 * harmless while the two rendered the same thing, and stopped being so once the
 * URL cell grew a favicon -- the phone cell inherited a favicon `<img>`, an
 * error handler and a watcher for a picture it could never have, since
 * `getFaviconUrl` returns null for a phone number.
 *
 * Matches `GridViewFieldPhoneNumber`, the selected-cell component, which also
 * renders through `grid-field-text`.
 */
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  name: 'FunctionalGridViewFieldPhoneNumber',
  components: { SearchHighlightedText },
  props: {
    value: {
      type: String,
      default: '',
    },
    searchTerm: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>
